import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import "./ThankyouStep.css";

function ThankyouStep({ language }) {
  const { t } = useTranslation();

  return (
    <Col className="thankyou-step">
      <Col className="center">
        <h5>
          {language === "es"
            ? "¡Gracias por compartir! Tu retroalimentación es muy valiosa y completamente anónima."
            : "Thank you for sharing. Your feedback is very valuable and completely anonymous."}
        </h5>
      </Col>
    </Col>
  );
}

export default ThankyouStep;
